import { Box, Center, Grid, Text } from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import AutoCrop from "App/BsesPoc/components/imageCropping/AutoCrop";
import { useContext, useEffect, useState } from "react";
import { appRequest } from "routes";

const WorkFlowDescForeign = ({
  activePage,
  showError,
  errors,
  values,
  handleChange,
  isDisabled,
  setFieldValue,
  handleLogoChange,
  handleOpenModal,
  loadOptions,
  isLoading,
  type
}: any) => {
  const [regionOptions, setRegionOptions] = useState<any[]>([]);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response: any = await appRequest("foreignRegion", "getall", {});
        if (response?.status === "success" && Array.isArray(response.data)) {
          const options = response.data.map((r: any) => ({
            label: r.regionName,
            value: r.regionName,
          }));
          setRegionOptions(options);
        }
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    };

    fetchRegions();
  }, []);

  console.log('the values are', values)

  return (
    <Box display={activePage === 0 ? undefined : "none"}>
      <Grid gap={6} templateColumns={{ md: "1fr 1fr" }}>
        <Box>
          <CustomInput
            label="Search Initiator"
            name="selectedUserProfile"
            type="select-async"
            loadOptions={loadOptions}
            value={values.selectedUserProfile}
            onChange={(e: any) => {
              setFieldValue('selectedUserProfile', e);
              // Update workflowName preview
              const userName = e?.email || "";
              const userPrefix = userName?.split('@')[0] || "";
              // Fallback to id if profileId is missing
              const profileId = e?.profileId || e?.id || "";
              const regionName = values.regions?.value || "";
              const formattedName = [userPrefix, profileId, regionName].filter(Boolean).join("-");
              setFieldValue('workFlowName', formattedName);
            }}
            getOptionLabel={(option: any) => option.email}
            getOptionValue={(option: any) => option.id}
            loading={isLoading}
            placeholder="Search User..."
            disabled={isDisabled}
            isBoxSelect={true}
          />
          <Text fontWeight="600" color="teal.500" mt={2}>{values.workFlowName}</Text>
        </Box>

        <CustomInput
          label="Flow Name"
          name="flowName"
          placeholder="Enter the Flow Name"
          error={errors.flowName}
          value={values.flowName}
          onChange={handleChange}
          showError={showError}
          disabled={isDisabled}
        />
        <CustomInput
          label="Identifier"
          name="identifier"
          error={errors.name}
          value={values.identifier}
          onChange={handleChange}
          showError={showError}
          disabled={true}
        />

        <CustomInput
          label="Add Document Type"
          name="documentType"
          placeholder="Enter the Document type"
          value={values.documentType}
          onChange={handleChange}
          showError={showError}
          disabled={isDisabled}
        />

        <CustomInput
          label="Select Regions"
          name="regions"
          type="select"
          placeholder={regionOptions.length > 0 ? "Select Regions" : "Loading regions..."}
          value={values.regions}
          onChange={(e: any) => {
            setFieldValue('regions', e);
            
            // Robust name generation: Extract base (prefix-id) from current name first
            let base = "";
            if (values.workFlowName) {
              const parts = values.workFlowName.split("-");
              // The base is the first two parts (user-id)
              if (parts.length >= 2) {
                base = parts.slice(0, 2).join("-");
              }
            }

            // Fallback to profile object if name splitting fails
            if (!base) {
              const userName = values.selectedUserProfile?.email || "";
              const userPrefix = userName?.split('@')[0] || "";
              const profileId = values.selectedUserProfile?.profileId || values.selectedUserProfile?.id || "";
              base = [userPrefix, profileId].filter(Boolean).join("-");
            }

            const regionName = e?.value || "";
            const formattedName = base ? `${base}-${regionName}` : regionName;
            setFieldValue('workFlowName', formattedName);
          }}
          showError={showError}
          disabled={isDisabled}
          getOptionLabel={(option: any) => option.label || (typeof option === 'string' ? option : "")}
          getOptionValue={(option: any) => option.value || (typeof option === 'string' ? option : "")}
          options={regionOptions}
          isBoxSelect={true}
          isMulti={type !== 'edit'}
        />
      </Grid>

      <Box display="none">
        <AutoCrop />
      </Box>

      <Grid mt={6}>
        <Center>
          <CustomInput
            type="file"
            name="logo"
            onChange={(e) => handleLogoChange(e, setFieldValue)}
            label="Upload Logo"
            rest={{ accept: "image/*" }}
            disabled={isDisabled}
          />
        </Center>
        {values && (
          <Box onClick={() => handleOpenModal ? handleOpenModal(values.logo) : null}>
            <Text
              textDecoration={"underline"}
              color="blue.400"
              cursor="pointer"
            >
              {values?.logo?.name}
            </Text>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default WorkFlowDescForeign;
